import {getEnv} from '../../common/env/env';
import {ItemSetDto} from '../../common/shared/api/gateway/ItemSetDto.interface';
import {getKageUrl} from '../../common/shared/utils/getKageUrl';
import {Set} from '../generated/types';
import {createAgeGrade} from './AgeGrade';
import {createAssetProperty} from './AssetProperty';
import {createOperatorProperty} from './OperatorProperty';
import {createServiceProperty} from './ServiceProperty';
import {createTicketKind} from './TicketKind';
import {createTicketType} from './TicketType';

export function createSet({
  set_id,
  series_id,
  title,
  thumbnail,
  product_count,
  start_sale_dt,
  end_sale_dt,
  ticket_type,
  price,
  all_volumes,
  discount_price,
  discount_rate,
  rental_period_by_minute,
  age_grade,
  category_uid,
  category,
  sub_category_uid,
  sub_category,
  authors,
  description,
  service_property,
  operator_property,
  asset_property,
}: ItemSetDto): Set {
  return {
    setId: set_id,
    seriesId: series_id,
    title,
    thumbnail: getKageUrl({
      kageUrlPrefix: getEnv().kageUrlPrefix,
      kageId: thumbnail,
      resolution: 'th3',
    }),
    productCount: product_count,
    startSaleDt: start_sale_dt,
    endSaleDt: end_sale_dt,
    ticketType: createTicketType(ticket_type),
    ticketKind: createTicketKind(ticket_type),
    price,
    allVolumes: all_volumes,
    discountPrice: discount_price,
    discountRate: discount_rate,
    discountRateText: discount_rate ? `${discount_rate}%` : undefined,
    rentalPeriodByMinute: rental_period_by_minute,
    ageGrade: createAgeGrade(age_grade),
    categoryUid: category_uid,
    category,
    subcategoryUid: sub_category_uid,
    subcategory: sub_category,
    authors,
    description,
    serviceProperty: service_property
      ? createServiceProperty(service_property)
      : undefined,
    operatorProperty: operator_property
      ? createOperatorProperty(operator_property)
      : undefined,
    assetProperty: asset_property
      ? createAssetProperty(asset_property)
      : undefined,
  };
}
